import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

export const SIMPLISTIC_THEMES = [
  { id: 'aurora', name: 'Aurora', colours: ['#7c3aed', '#2563eb'] },
  { id: 'default', name: 'Default', colours: ['#f0f4f8', '#192230'] },
  { id: 'dark', name: 'Dark', colours: ['#111827', '#273449'] },
  { id: 'light', name: 'Light', colours: ['#ffffff', '#e2e8f0'] },
  { id: 'blue', name: 'Blue', colours: ['#eff6ff', '#1d4ed8'] },
  { id: 'green', name: 'Green', colours: ['#ecfdf5', '#15803d'] },
  { id: 'indigo', name: 'Indigo', colours: ['#eef2ff', '#4f46e5'] },
  { id: 'cartoony', name: 'Playful', colours: ['#ec4899', '#f97316'] },
  { id: 'purple', name: 'Purple', colours: ['#faf5ff', '#9333ea'] },
];
const validTheme = value => SIMPLISTIC_THEMES.some(theme => theme.id === value) ? value : 'default';
const ThemeContext = createContext({ theme: 'default', setTheme: () => {} });

export const themeStorageKey = username => `simplisticTheme:${String(username || 'admintcg').toLowerCase()}`;

export function SimplisticThemeProvider({ children, username }) {
  const merchant = username || (typeof window !== 'undefined' ? window.location.pathname.split('/').filter(Boolean)[0] : '') || 'admintcg';
  const key = themeStorageKey(merchant);
  const readTheme = useCallback(() => {
    try { return validTheme(window.localStorage.getItem(key)); } catch { return 'default'; }
  }, [key]);
  const [theme, updateTheme] = useState(readTheme);
  useEffect(() => { updateTheme(readTheme()); }, [readTheme]);
  const setTheme = useCallback(value => {
    const next = validTheme(value);
    updateTheme(next);
    try { window.localStorage.setItem(key, next); } catch { /* The chosen theme still works when storage is unavailable. */ }
  }, [key]);
  useEffect(() => {
    const syncTheme = event => { if (event.key === key) updateTheme(validTheme(event.newValue)); };
    window.addEventListener('storage', syncTheme);
    return () => window.removeEventListener('storage', syncTheme);
  }, [key]);
  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
}

export const useSimplisticTheme = () => useContext(ThemeContext);
